module.exports = __webpack_public_path__ + "img/logo2.a2f5c02e.png";